"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAlgoliaSearchResult = void 0;
const types_1 = require("../types");
const mapAlgoliaPageToPage_1 = require("./mapAlgoliaPageToPage");
const mapAlgoliaProductToProduct_1 = require("./mapAlgoliaProductToProduct");
const mapAlgoliaQuerySuggestionsToQuerySuggestions_1 = require("./mapAlgoliaQuerySuggestionsToQuerySuggestions");
const mapAlgoliaSearchResult = (objectType, hit) => {
    switch (objectType) {
        case types_1.ObjectType.Product:
            return (0, mapAlgoliaProductToProduct_1.mapAlgoliaProductToProduct)(hit);
        case types_1.ObjectType.Page:
            return (0, mapAlgoliaPageToPage_1.mapAlgoliaPageToPage)(hit);
        case types_1.ObjectType.QuerySuggestions:
            return (0, mapAlgoliaQuerySuggestionsToQuerySuggestions_1.mapAlgoliaQuerySuggestionsToQuerySuggestions)(hit);
        default:
            return hit;
    }
};
exports.mapAlgoliaSearchResult = mapAlgoliaSearchResult;
//# sourceMappingURL=mapAlgoliaSearchResult.js.map